export default __webpack_public_path__ + "static/media/education.2c8509fb.webp";